import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import hooks from "./ModalHook";
function ModalComp(props) {
    const { modalStyle, classes } = hooks(props)
    return (
        <Modal
            open={props.open}
            onClose={() => props.setValue()}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
        >
            <div style={modalStyle} className={classes.paper}>
                {props.body}
            </div>
        </Modal>
    )
}
export default ModalComp;